import { MessageCircle } from "lucide-react";
import { openWhatsApp } from "../utils/whatsappLink";

export default function WhatsAppButton({ whatsappNumber }) {
  if (!whatsappNumber) return null;

  const handleWhatsAppClick = () => {
    openWhatsApp(whatsappNumber, "Hola!");
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-24 md:bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300 z-50 animate-bounce"
      title="Chat por WhatsApp"
      style={{
        animation: 'bounce 2s infinite'
      }}
    >
      <MessageCircle className="w-6 h-6" />
    </button>
  );
}
